var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('homeWeb'):_vm._e(),(_vm.isMobile)?_c('homeMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }